/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */


/**
 * Enum pour l'authentification
 * @readonly
 * @enum { string }
 */

export enum LoginTypes {

    /** @type {string} */

    LOGIN_SUCCESS = '[TOLLSENSE] La connection a réussi ...',
    LOGIN_FAIL = '[TOLLSENSE] La connection a échoué ...',
    LOGIN_INPROGRESS = '[TOLLSENSE] La connection est en cours ...',
    
}
/**
 * Enum pour l'authentification
 * @readonly
 * @enum { string }
 */

export enum DeconnexionTypes {

    /** @type {string} */

    DECONNEXION_SUCCESS = '[TOLLSENSE] La déconnexion  a réussi ...',
    DECONNEXION_FAIL = '[TOLLSENSE] La déconnexion  a échoué ...',
    DECONNEXION_INPROGRESS = '[TOLLSENSE] La déconnexion  est en cours ...',
    
}
/**
 * Enum pour l'authentification
 * @readonly
 * @enum { string }
 */

export enum RealTimesTypes {

    /** @type {string} */

    REALTIMES_SUCCESS = '[TOLLSENSE] Le chargement des dectection du modèle en temp réel a réussi ...',
    REALTIMES_FAIL = '[TOLLSENSE] Le chargement des dectection du modèle en temp réel a échoué ...',
    REALTIMES_INPROGRESS = '[TOLLSENSE] Le chargement des dectection du modèle en temp réel est en cours ...',
    
}

/**
 * Enum pour l'authentification
 * @readonly
 * @enum { string }
 */

export enum DelayedTypes {

    /** @type {string} */

    DELAYED_SUCCESS = '[TOLLSENSE] Le chargement des dectection du modèle en temps différé a réussi ...',
    DELAYED_FAIL = '[TOLLSENSE] Le chargement des dectection du modèle en temps différé a échoué ...',
    DELAYED_INPROGRESS = '[TOLLSENSE] Le chargement des dectection du modèle en temps différé est en cours ...',
    
}


/**
 * Enum pour les stats
 * @readonly
 * @enum { string }
 */

export enum StatsTypes {

    /** @type {string} */

    STATS_SUCCESS = '[TOLLSENSE] Le chargement des stats a réussi ...',
    STATS_FAIL = '[TOLLSENSE] Le chargement des stats a échoué ...',
    STATS_INPROGRESS = '[TOLLSENSE] Le chargement des stats est en cours ...',
    
}


// WEBPACK FOOTER //
// ./src/apps/store/enums/actions/index.ts